import { Button, IconButton, InputAdornment, makeStyles, TextField } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import Modal from '@mui/material/Modal';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { IN_ROOM_DINING_MENU_CREATE } from '../../../../../constants/InRoomDiningConst';
import { getMenuFormData } from '../../../servicesSlice';

function getModalStyle(top, left) {
  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
    paddingLeft: '60px',
    paddingRight: '60px',
    height: '85vh',
    overflowY: 'auto',
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 500,
    backgroundColor: theme.palette.background.paper,
    border: 'none',
    borderRadius: '10px',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    overflowY: 'auto',
  },
}));

const MenuModal = (props) => {
  const { menuModal, setMenuModal, onViewToggle, posMenuList, setPosMenuList, hotelId } = props;
  const dispatch = useDispatch();
  const classes = useStyles();
  const modalStyle = getModalStyle(50, 50);
  const [searchText, setSearchText] = useState('');
  const filteredMenuList = React?.useMemo(() => {
    if (!searchText) return posMenuList;
    return posMenuList?.filter(
      (pos) => pos?.name && pos?.name?.toLowerCase()?.includes(searchText?.toLowerCase()),
    );
  }, [searchText, posMenuList]);

  const onSelectPosMenu = (posObject, posIndex) => {
    if (posObject.status === 'SYNCED') return true;
    const posListArray = [...posMenuList].map((obj, i) => {
      const currObj = { ...obj };
      currObj.isSelected = posIndex === i ? true : false;
      return currObj;
    });
    setPosMenuList(posListArray);
    dispatch(
      getMenuFormData({
        name: posObject.type,
        code: posObject.code,
        description: '',
        isActive: true,
        hours: [],
        categories: [],
        images: [],
        hotelId,
      }),
    );
  };

  const handleCancelClick = async (e) => {
    e.preventDefault();
    resetPos();
    setMenuModal(false);
  };

  const handleImportClick = () => {
    resetPos();
    onViewToggle(IN_ROOM_DINING_MENU_CREATE, true, null);
  };

  const isDisabled = () => {
    return !posMenuList.some((e) => e.isSelected);
  };

  const resetPos = () => {
    const posListArray = [...posMenuList].map((obj) => {
      const currObj = { ...obj };
      if (currObj.isSelected) {
        currObj.isSelected = false;
      }
      return currObj;
    });

    setPosMenuList(posListArray);
  };

  return (
    <Modal open={menuModal}>
      <div style={modalStyle} className={classes.paper}>
        <div className='ird-modal-body'>
          <p className='ird-menu-title'>Import Menu</p>
          <p className='ird-menu-sub-title'>Select menu you want to import from POS</p>
        </div>
        <div className='text-center mb-3'>
          <TextField
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            label='Search'
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position='end'>
                  <IconButton>
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </div>
        <div>
          {filteredMenuList && filteredMenuList?.length > 0 ? (
            filteredMenuList?.map((pos, posNdx) => (
              <div
                key={pos.id}
                className={`row ${
                  pos.isSelected ? 'ird-menu-pos-box-select ' : 'ird-menu-pos-box '
                }`}
                onClick={() =>
                  onSelectPosMenu(
                    pos,
                    posMenuList.findIndex((p) => p?.id === pos?.id),
                  )
                }
              >
                <div className='col-md-8 mt-2'>{pos?.name}</div>
                <div className='col-md-4 mt-2'>
                  <div
                    className={`${pos?.status === 'SYNCED' ? 'pill-active ' : 'pill-inactive '} 
                         pill d-flex justify-content-center align-items-center`}
                  >
                    <span className='ms-1'>
                      {pos.status === 'SYNCED' ? 'Synced' : 'Not Synced'}
                    </span>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className='text-center text-muted'>No menus found.</div>
          )}
        </div>
        <div className='justify-content-center mt-3 row'>
          <div className='col-md-4'>
            <Button
              variant='outlined'
              type='button'
              color='secondary'
              size='large'
              onClick={(e) => handleCancelClick(e)}
            >
              Cancel
            </Button>
          </div>
          <div className='col-md-4'>
            <Button
              variant='contained'
              type='button'
              color='primary'
              className='me-3'
              size='large'
              onClick={(e) => {
                handleImportClick();
              }}
              disabled={isDisabled()}
            >
              Import
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default MenuModal;
